// extracted by mini-css-extract-plugin
export default {"wrapper":"Paper_wrapper__UfJqS","header":"Paper_header__TGHxi","anchor":"Paper_anchor__Y1heM","heading":"Paper_heading__Q6U8A","text":"Paper_text__sOJJ8"};